<template>
	<RouterView />
</template>

<script lang="ts">
	import store from './store';
	import { defineComponent } from 'vue';
	export default defineComponent({
		provide: {
			'$store': store
		},
		head: {
			titleTemplate: (title) => {
				if (title) {
					if (title.includes('-') || title === 'Cognito Forms')
						return `${title}`;
					else
						return `${title} - Cognito Forms`;
				}
				else
					return 'Cognito Forms - Easily Build Powerful Forms';
			},
			meta: [
				{
					name: 'viewport',
					content: 'width=device-width, initial-scale = 1.0, minimum-scale = 1.0, maximum-scale = 1.0, minimal-ui, viewport-fit=cover'
				},
				{
					name: 'apple-mobile-web-app-capable',
					content: 'yes'
				},
				{
					'http-equiv': 'X-UA-Compatible',
					content: 'IE=edge'
				},
				{ property: 'twitter:card', content: 'summary_large_image', id: 'twitter:card' },
				{ property: 'twitter:site', content: '@CognitoForms', id: 'twitter:site' },
				{ property: 'twitter:creator', content: '@CognitoForms', id: 'twitter:creator' },
				{ property: 'og:site_name', content: 'Cognito Forms', id: 'og:site_name' }
			],
			htmlAttrs: {
				lang: 'en'
			}
		}
	});
</script>